import React from 'react';
import * as properties from '../../elementsPropertiesItems';
// import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';

const FontFamily =(props)=>{
	const {path,keyParam,alignTypes,elementData} = props;
	let fontFamilyValue = isSet(elementData,null)!==null?isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:"'Arial', sans-serif":"'Arial', sans-serif";

	const changeHandler = (e) => {
        const {value} = e.target;        
        props.changeHandler(path,keyParam,value)
    }

    return(
        <div className="w-100">
			<select className="form-control input-border-bottom1" onChange={e=>changeHandler(e)}> 
				{
                    properties.FontFamilyTypes.map((item,ind)=>{
                        let isSelected = '';
                        if(item.value === fontFamilyValue){
                           isSelected = 'selected';
                        }
                        return(
                            <option selected={isSelected} value={item.value}> {item.label} </option>    
                        )
                    })
                }                 				
			</select>
			 
		</div>
    )
}

FontFamily.defaultProps = {
    fontWeightValue: "'Arial', sans-serif",    
};

export default FontFamily;
